import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import Message from '../message';
import TotoC from './toto';
import UnderHeader from "../underHeader";

@inject('totoStore', 'dictStore')
@observer
export default class TotoContainer extends Component{

  componentDidMount() {
    this.props.totoStore.Toto.init();
  }

  render() {
    const {isLoading, result, Toto} = this.props.totoStore;
    const {getLang} = this.props.dictStore;
    return(
      <Fragment>
        <div className="blue_line">
          <UnderHeader type={2} />
        </div>
        {
          !isLoading ?
            <div className="toto-index-loading">
              <LoadingSpinner />
            </div> :
            <Fragment>
              {Toto.data ? <TotoC /> : <div className="toto-index-no">{getLang('NO_ACTIVE_DRAWS_AT_THE_MOMENT')}</div>}
            </Fragment>
        }
      </Fragment>

    )
  }
}


// WEBPACK FOOTER //
// ./src/components/toto/index.jsx